/**
 * The goodbye page's route contract (Jason, R207: "on sign out needs to auto
 * out to the goodbye page"). Sign-out hard-navigates here (useAuth.signOut),
 * and App.tsx renders <Goodbye/> for this path BEFORE the signed-out SignIn
 * gate — the one path a signed-out user sees that isn't the sign-in screen.
 * Pure + exported for the house pinning-test convention (homeRouteGate.ts's
 * own pattern, one door up).
 */
export const GOODBYE_PATH = '/goodbye';

export function shouldRenderGoodbye(pathname: string): boolean {
  return pathname === GOODBYE_PATH || pathname === `${GOODBYE_PATH}/`;
}
